<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    style="padding-top: 15px; padding-left: 30px; padding-right: 30px;"
    v-if="settings != null"
>
    <div
        v-if="!settings.provision_branded_link_shortener"
        style="text-align: center"   
    >
    <p>Your organization's RedChirp plan does not included branded link shortening.</p>
    <p>contact us today to upgade!</p>

    <p
        v-if="$rc.$state.isSystemsAdmin"
    >
        <b>System Administrators:</b> access is controlled via the provision section on the organization settings page.
    </p>
</div>

    <h2>
        Branded Short Hosts
    </h2>

    <v-data-table
        :headers="headers"
        :items="settings.branded_hosts"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
        <template
            v-slot:item.is_default="{ item }"
            v-ripple="false"
        >
            <v-simple-checkbox
                disabled
                color="primary"
                v-model="item.is_default"
            >
                {{item.is_default}}
            </v-simple-checkbox>
        </template>

        <template
            v-slot:item.is_active="{ item }"
            v-ripple="false"
        >
            <v-simple-checkbox
                disabled
                color="primary"
                v-model="item.is_active"
            >
                {{item.is_active}}
            </v-simple-checkbox>
        </template>
    
        <template v-slot:item.example="{ item }">
            <a 
                :href="exampleURL(item,false)"
                target="_blank"
            >
                {{exampleURL(item,true)}}
            </a>
        </template>
    
        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>

                <v-list-item
                    v-on:click="onClickMakeDefault(item)"
                    v-if="item.is_default == false"
                >
                    <v-list-item-title>Make default</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickMakeActive(item)"
                    v-if="item.is_active == false"
                >
                    <v-list-item-title>Make active</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickMakeInActive(item)"
                    v-if="item.is_active == true"
                >
                    <v-list-item-title>Make inactive</v-list-item-title>
                </v-list-item>

                <v-divider
                    v-if="item.is_active == false"
                />

                <v-list-item
                    v-on:click="onClickDelete(item)"
                    v-if="item.is_active == false"
                >
                    <v-list-item-title>Delete...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <div
        style="text-align: right; margin-top: 15px;"
    >
        <v-btn
            color="primary"
            dark
            fab
            v-on:click="onClickAddHost"
            style="margin-right: 8px;"
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </div>

    <m-settings-organization-branded-link-shortener-add-host-dialog
        ref="add-host"
        v-on:add-host="onAddHost($event)"
    />

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            settings: null,

            headers: [
                { text: 'Default', value: 'is_default' },
                { text: 'Host', value: 'host' },
                { text: 'Example Link', value: 'example' },
                { text: 'Is Active', value: 'is_active'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'GET: /api/v1/branded-link-shortener/settings/:organization_id',
            
                {
                    'organization_id': this.$route.params.organization_id,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.settings = data;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickMakeActive(item)
        {
            item.is_active = true;
            this.putBrandedHost(item);
        },

        onClickMakeDefault(item)
        {
            item.is_default = true;
            item.is_active = true;
            this.putBrandedHost(item);
        },

        onClickMakeInActive(item)
        {
            item.is_active = false;
            item.is_default = false;
            this.putBrandedHost(item);
        },

        putBrandedHost(host)
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /api/v1/branded-link-shortener/settings/host',
            
                host,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.update();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to update host');
                },
            );
        },

        onClickDelete(host)
        {
            this.$rc.confirm(
                'Confirm Delete',
                'Are you sure that you would like to permenantly delete '+host.host+'?',
                [
                    {'text': 'Cancel', 'value': 'cancel'},
                    {'text': 'Confirm', 'value': 'confirm'},
                ],
            
                (response) => {
                    if (response != 'confirm') return;
                    
                    this.doDelete(host);
                }
            );
        },

        doDelete(host)
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'DELETE: /api/v1/branded-link-shortener/settings/host',
            
                host,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.update();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to delete host');
                },
            );
        },

        onClickAddHost()
        {
            this.$refs['add-host'].showDialog();
        },

        onAddHost(host)
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /api/v1/branded-link-shortener/settings/host',
            
                host,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.update();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to add host');
                },
            );
        },

        exampleURL(item, count_hits)
        {
            if ( count_hits )
                return item.example_url_count_hits;
            else
                return item.example_url_no_count_hits;
        }
    },

    computed: {
        title() {
            if ( this.settings == null ) 
                return 'Branded Link Shortener Settings';
                
            return this.settings.organization_label+': Branded Link Shortener Settings';
        }
    },
}
</script>

<style lang="scss" scoped>
</style>